import React from 'react'
import { useTranslation } from 'react-i18next'
import { Typography, Button, Card, Row, Col, Tag } from 'antd'
import { UserOutlined } from '@ant-design/icons'
import { s } from './style'
import numeral from 'numeral'
import { NUMERAL_FORMAT } from '../../../Constants'
import { Link } from 'react-router-dom'
import TransportIcon from '../TransportIcon'
import { formatCents } from '../../../Utilities'
import { AllPropsProposalCardProposalFragment } from './ProposalCard.generated-types'

const { Text } = Typography
interface CompProps {
  proposal: AllPropsProposalCardProposalFragment
  goToProposal: () => void
}

export const ProposalCard: React.FC<CompProps> = ({
  proposal: {
    baseCostTotal,
    space: {
      spaceName,
      venue,
      venue: { nearestTransit },
      spacePhotos,
    },
    attendees,
    currency,
    status,
  },
  goToProposal,
}) => {
  const { t } = useTranslation()

  const isRequestedToBooked = status === 'RequestedToBook'

  return (
    <Card
      hoverable
      style={s.proposalCard}
      cover={
        <section style={{ position: 'relative' }}>
          <img
            alt={`${spaceName}, ${venue.name}`}
            src={spacePhotos[0].url}
            style={{ ...s.img, width: '100%' }}
          />
          {isRequestedToBooked && (
            <Tag color='blue' style={{ position: 'absolute', top: 8, left: 8 }}>
              {t('label.requestedToBook', 'Requested to book')}
            </Tag>
          )}
        </section>
      }>
      <Row justify='space-between' gutter={[0, 24]}>
        <Col>
          <Text style={s.spaceName}>{spaceName}</Text>
          <br />
          <Text style={s.venueName}>{venue?.name}</Text>
        </Col>
        <Col>
          <Text style={s.labelText}>{formatCents(currency, baseCostTotal)}</Text>
        </Col>
      </Row>
      <Row justify='space-between' gutter={[0, 24]}>
        {nearestTransit && (
          <Col>
            <Text style={s.labelText}>
              <TransportIcon width={16} height={16} />
              {` ${nearestTransit.station}`}
            </Text>
            <br />
            <Text style={s.smallText}>
              {`${numeral(nearestTransit.distanceKm).format('0.0')} ${t(
                'proposal.distance',
                'km away'
              )}`}
            </Text>
          </Col>
        )}
        <Col>
          <UserOutlined />
          {` ${numeral(attendees).format(NUMERAL_FORMAT)}`}
        </Col>
      </Row>
      <Button block type='primary' onClick={() => goToProposal()} style={{ cursor: 'pointer' }}>
        <Link to='/'>
          {isRequestedToBooked
            ? t('response.viewChosenResponse', 'View chosen response')
            : t('response.viewResponse', 'View response')}
        </Link>
      </Button>
    </Card>
  )
}
